<template>
  <div>
    <v-date-picker
      v-model="data.deliverydate"
      :min="minDeliveryDate"
      :max="maxDeliveryDate"
      class="cakeDatePicker"
      color="secondary"
      style="height: 400px !important"
      landscape
      :show-current="false"
      :locale-first-day-of-year="1"
      :first-day-of-week="1"
      full-width
      :allowed-dates="allowedDates"
      :title-date-format="customTitleDateFormat"
      :weekday-format="weekdayFormat"
    ></v-date-picker>

    <v-row align="center" class="my-9">
      <v-col md="6">
        <v-btn
          class="text-capitalize"
          plain
          x-large
          block
          rounded
          @click="cakeStore.decrease()"
          >Geri Git
        </v-btn>
      </v-col>
      <v-col md="6">
        <v-btn
          color="secondary"
          class="text-capitalize"
          depressed
          rounded
          x-large
          block
          @click="continueStep()"
        >
          Devam Et
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";

// Utils
import {
  postData,
  addDays,
  formatDate,
  weekdayFormat,
  hoursAndMinutes,
  hoursAndMinutesSelect,
  CITY_STATE,
} from "@utils";
import { useRouter } from "@core/utils";

// Store
import { useCakeStore } from "@/stores/cake";

export default {
  setup() {
    // Store
    const cakeStore = useCakeStore();

    const { route } = useRouter();

    const data = ref({
      deliverydate: formatDate(addDays(cakeStore.minDelivery)),
    });

    const minDeliveryDate = ref(formatDate(addDays(cakeStore.minDelivery)));
    const maxDeliveryDate = ref(formatDate(addDays(cakeStore.maxDelivery)));

    const continueStep = async () => {
      cakeStore.data.delivery = data.value;
      cakeStore.increment();
    };

    onMounted(async () => {
      if (route.value.params.item) {
        data.value = cakeStore.data.delivery;
      }
    });

    const customTitleDateFormat = (isoDate) => {
      const currentDate = new Date(isoDate);
      const weekday = currentDate.toLocaleString("default", {
        weekday: "long",
      });
      const day = currentDate.toLocaleString("default", { day: "numeric" });
      const month = currentDate.toLocaleString("default", { month: "long" });
      const year = currentDate.toLocaleString("default", { year: "numeric" });

      return (
        day +
        " " +
        month +
        "<br>" +
        weekday +
        "<br><span class='text-h6 text--disabled'>" +
        year +
        "</span>"
      );
    };

    const allowedDates = (val) => {
      const hariciTarihler = cakeStore.currentDate
console.log(val,cakeStore.currentDate);
      if (hariciTarihler.includes(val)) {
        return val;
      }
    };
    return {
      allowedDates,
      customTitleDateFormat,
      minDeliveryDate,
      maxDeliveryDate,
      weekdayFormat,
      cakeStore,
      continueStep,
      data,
    };
  },
};
</script>

<style lang="scss">
.cakeDatePicker {
  .v-date-picker-title__year {
    display: none;
  }
  .v-date-picker-title__date {
    line-height: 1.25;
  }
  .v-date-picker-table .v-btn {
    width: 50px !important;
    height: 50px !important;
  }
  .v-picker__body {
    margin-left: 300px !important;
    border-radius: 24px !important;
    border: none !important;
  }
  .v-picker__title--landscape {
    width: 275px;
    border-radius: 24px !important;
    padding: 32px;
  }
  .v-date-picker-header {
    padding: 24px !important;
  }
}
</style>
